import { createAction } from 'typesafe-actions';
import { Dispatch } from 'redux';
import {
    GET_CONTENT_TYPES_REQUEST,
    GET_CONTENT_TYPES_SUCCESS,
    GET_CONTENT_TYPES_FAILURE,
} from './catalogConstants';
import { client } from '../Common/gql/client';
import { contentTypesQuery } from './contentTypesQuery';
import { ContentType } from '../Common/types/CatalogTypes';

export const getContentTypesRequest = createAction(GET_CONTENT_TYPES_REQUEST)();
export const getContentTypesSuccess = createAction(GET_CONTENT_TYPES_SUCCESS)<
    ContentType[]
>();
export const getContentTypesFailure = createAction(GET_CONTENT_TYPES_FAILURE)<
    Error
>();

export const queryContentTypes = () =>
    client.query({
        query: contentTypesQuery,
    });

export const getContentTypes = () => async (
    dispatch: Dispatch,
): Promise<ContentType[] | void> => {
    dispatch(getContentTypesRequest());
    queryContentTypes()
        .then(result => {
            const contentTypes = result.data.getContentTypes;
            dispatch(getContentTypesSuccess(contentTypes));
            return contentTypes;
        })
        .catch(error => dispatch(getContentTypesFailure(error)));
};
